import { Typography } from "@mui/material";
import Breadcrumb from '../../components/Breadcrumbs/Breadcrumbs';

const LiveChatSupport =() => {
    return(
      <>
     <Breadcrumb />
      <Typography>
          LiveChatSupport works
       </Typography>
       </>
       );
};
export default LiveChatSupport;